<template>
  <div class="accardion-content accardion-content-active">
    <div class="policy-accardion-items-header">
      <div class="policy-accardion-items-title" style="width: 25%;">Страховой год</div>
      <div class="policy-accardion-items-title" style="width: 25%;">Начало</div>
      <div class="policy-accardion-items-title" style="width: 25%;">Окончание</div>
      <div class="policy-accardion-items-title" style="width: 25%;">Купонный барьер, %</div>
    </div>
    <div v-for="(barrier, key) in barriers" :key="key" class="policy-accardion-items">
      <div class="policy-accardion-items-text" style="width: 25%;">{{ barrier.ins_year }}</div>
      <div class="policy-accardion-items-text" style="width: 25%;">{{ barrier.date_beg }}</div>
      <div class="policy-accardion-items-text" style="width: 25%;">{{ barrier.date_end }}</div>
      <div class="policy-accardion-items-text" style="width: 25%;">{{ barrier.coupon_barrier }} %</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarrierComponent",
  props: ['barriers','visible'],
}
</script>